const reducer = (state = {}, action) => {
    switch (action.type) {
        case 'GET_CONFIRMATION_ORDER_STATUS':
            return { ...state, getConfiramtionOrderInfoResponse: action.data };

        default:
            return state;
    }
};
export default reducer;